export const CONNECTED = 'CONNECTED';
export const DISCONNECTED = 'DISCONNECTED';
